import SaveForLater from './save-for-later';

export default class SaveForLaterUtil {
    constructor() {
        this.myAccount = window.HONDA.MyAccount;
        this.myAccount2 = window.HONDA.MyAccount2;
        this.saveForLater = new SaveForLater(this);
        this.html = document.querySelector('html');
        this.bind();
        this.sync();
    }

    save(data) {
        const item = this.saveForLater.create(data.type, 'data', data);
        if (item) {
            this.saveForLater.save(item);
        }
    }

    bind() {
        this.html.addEventListener('history.replaceState', () => this.sync());
        this.html.addEventListener('history.pushState', () => this.sync());
    }

    sync() {
        if (window.location.pathname === '/account/my-account/profile') {
            this.saveForLater.sync();
        }
    }

    update(updated) {
        if (updated?.remote) {
            window.location.reload();
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const util = new SaveForLaterUtil();
    window.HONDA.SaveForLater = util;
});
